<!-- app/frontend/pages/Dashboard/Show.svelte -->
<script context="module">
  import AppLayout from '$lib/layouts/AppLayout.svelte'
  export const layout = AppLayout
  
</script>

<script lang="ts">
  // 但 inertia_rails + vite 通常直接从 props 拿
  let { stats, recent_activity = [], chart_data = { labels: [], values: [] } } = $props();
  let myTitle = "123";
  // 你可以在这里做一些客户端计算、格式化等
</script>

<div class="bg-background text-foreground w-full">
  <!-- Header / Navbar 可以做成共享 Layout 或单独组件 -->
  <!-- <header class="border-b">
    <div class=" flex h-16 items-center justify-between">
      <h1 class="text-2xl font-bold">控制台</h1>
    </div>
  </header> -->

  <main class="w-full py-6">
    <!-- 统计卡片 -->
    <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <div class="rounded-lg border bg-card p-6 shadow-sm">
        <p class="text-sm text-muted-foreground">Total Users</p>
        <p class="text-3xl font-bold">{stats.total_users}</p>
      </div>
      <div class="rounded-lg border bg-card p-6 shadow-sm">
        <p class="text-sm text-muted-foreground">Active Now</p>
        <p class="text-3xl font-bold">{stats.active_now}</p>
      </div>
      <div class="rounded-lg border bg-card p-6 shadow-sm">
        <p class="text-sm text-muted-foreground">New Signups</p>
        <p class="text-3xl font-bold">{stats.new_signups}</p>
      </div>
      <div class="rounded-lg border bg-card p-6 shadow-sm">
        <p class="text-sm text-muted-foreground">Revenue</p>
        <p class="text-3xl font-bold">${stats.revenue.toLocaleString()}</p>
      </div>
    </div>

    <!-- 最近活动 + 图表区域 -->
    <div class="mt-8 grid gap-6 md:grid-cols-2">
      <!-- 最近活动 -->
      <div class="rounded-lg border bg-card">
        <div class="p-6">
          <h2 class="text-lg font-semibold">Recent Activity</h2>
        </div>
        <div class="divide-y">
          {#each recent_activity as item (item.id)}
            <div class="flex items-center justify-between px-6 py-4">
              <div>
                <p class="font-medium">{item.action}</p>
                <p class="text-sm text-muted-foreground">{item.time}</p>
              </div>
            </div>
          {/each}
        </div>
      </div>

      <!-- 示例图表区域（可以用 recharts-svelte 或自己用 canvas） -->
      <div class="rounded-lg border bg-card p-6">
        <h2 class="text-lg font-semibold mb-4">Revenue Trend</h2>
        <!-- 这里你可以集成图表库，比如 svelte-chartjs 或自己写 SVG -->
        <!-- 暂时用简单 div 模拟 -->
        <div class="h-64 bg-muted/30 rounded flex items-end justify-around gap-2 p-4">
          {#each chart_data.values as value, i}
            <div
              class="bg-primary w-12 rounded-t"
              style="height: {value / Math.max(...chart_data.values) * 100}%"
              title="{chart_data.labels[i]}: {value}"
            ></div>
          {/each}
        </div>
      </div>
    </div>
  </main>
</div>